import React from 'react';
import { useSelector } from 'react-redux';

import PaymentSection from '../sections/PaymentSection';

const Payment = props => {
    const paymentFields = useSelector(
    state => state['features/clickandpledge']?.paymentSection || []
    );

    return (
        <>
            <PaymentSection
                isDonePayment = { props.isDonePayment }
                paymentValidator = { props.paymentValidator }
                paymentinfo = { paymentFields }
                sectionid = 'payment'
                sectionname = 'PaymentSection' />
        </>
    );
};

export default Payment;
